import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DecimalPipe } from '@angular/common';

import { FilterGroup } from '../../../../models/filter-group.model';
import { FilterItem } from '../../../../models/filter-item.model';
import { applyFilterAction, isEmptyArray } from '../../../../shared/utils';
import { FilterItemLabel } from '../../../../enums/filter-item-label';

@Component({
  selector: 'selected-filters',
  templateUrl: './filter-selected-group.component.html',
  styleUrls: ['./filter-selected-group.component.scss'],
  providers: [DecimalPipe],
  standalone: false,
})
export class FilterSelectedGroupComponent {
  _selectedFilters: FilterItem[] = [];
  _filterGroups: FilterGroup[];

  @Input() set filters(val: FilterGroup[]) {
    this._filterGroups = val;
    this._selectedFilters = this.getSelectedFilters(this._filterGroups);
  }

  @Output() removeFilter = new EventEmitter<FilterGroup[]>();

  constructor(private decimalPipe: DecimalPipe) {}

  onRemove(removedItem: FilterItem): void {
    this._filterGroups.forEach((filterGroup) => {
      applyFilterAction(filterGroup, (item: FilterItem) => {
        if (item.label === removedItem.label) {
          item.selected = false;
        }
      });
    });
    this._selectedFilters = this.getSelectedFilters(this._filterGroups);

    this.removeFilter.emit(this._filterGroups);
  }

  getFilterItemContent(filterItem: FilterItem): string {
    if (filterItem.label === FilterItemLabel.PriceRange) {
      return `$${this.formatFromNumber(filterItem.minPrice)} - $${this.formatFromNumber(filterItem.maxPrice)}`;
    }

    return filterItem.label;
  }

  private getSelectedFilters(filterGroups: FilterGroup[]): FilterItem[] {
    const result: FilterItem[] = [];

    if (filterGroups) {
      filterGroups.forEach((filterGroup) => {
        if (!isEmptyArray(filterGroup.selectedFilters)) {
          filterGroup.selectedFilters.forEach((filterItem) => {
            // skip already selected filter
            if (!result.find((i) => i.label === filterItem.label)) {
              result.push(filterItem);
            }
          });
        }
      });
    }

    return result;
  }

  private formatFromNumber(value: number | string): string {
    return this.decimalPipe.transform(value);
  }
}
